<template>
  <div v-if="currentProfil">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Profil du participant'"
          :description="'Gestion des informations du participant'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentProfil.session.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between">
                    <span>
                      Intitulé de la formation :
                      {{ currentProfil.session.formation.intitule }}
                    </span>
                    <span>
                      <router-link
                        title="Aperçu"
                        :to="{
                          name: 'rh_formation-show',
                          params: { id: currentProfil.session.formation.id },
                        }"
                        class="mr-4"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                        Aperçu
                      </router-link>
                    </span>
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence :
                    {{ currentProfil.session.formation.reference }}
                  </td>
                  <td class="col-6">
                    Durée :
                    {{ currentProfil.session.formation.duree + ' H' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td
                    class="col-6 text-custom-primary d-flex justify-content-between"
                  >
                    <span>
                      Référence :
                      {{ currentProfil.session.document.reference }}
                    </span>
                    <span>
                      <router-link
                        title="Aperçu"
                        :to="{
                          name: 'rh_formation_session-show',
                          params: {
                            sessionId: currentProfil.session.id,
                            sprov: sprov,
                          },
                        }"
                        class="mr-4"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                        Aperçu
                      </router-link>
                    </span>
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="{
                        'text-warning':
                          currentProfil.session.statut === 0 ||
                          currentProfil.session.statut === 5,
                        'text-danger': currentProfil.session.statut === 3,
                        'text-success':
                          currentProfil.session.statut === 1 ||
                          currentProfil.session.statut === 2 ||
                          currentProfil.session.statut === 4,
                      }"
                    ></i>
                    {{ getStatutSession(currentProfil.session.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between">
                    Prénom et nom du participant :
                    {{
                      currentProfil.employe.prenom
                        ? currentProfil.employe.prenom +
                          ' ' +
                          currentProfil.employe.nom
                        : currentProfil.employe.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push(prov).catch(() => {})"
        >
          Fiche de contrôle de presence
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'rh_formation_session_profil',
                params: { id: currentProfil.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-user text-custom-primary font-size-17"></i>
              Profil du participant
            </b-nav-item>
            <b-nav-item
              :to="{
                name: 'rh_formation_session_profil_evaluation',
                params: {
                  id: currentProfil.id,
                },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Evaluations</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_formation_session_profil_competence',
                params: { id: currentProfil.id },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Compétences</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'rh_formation_session_profil_habilitation',
                params: {
                  id: currentProfil.id,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Habilitations</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      prov: this.$route.params.prov,
      sprov: this.$route.params.sprov,
      title: 'Profil du participant',
    };
  },
  computed: {
    ...mapGetters('profilParticipant', ['currentProfil']),
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('profilParticipant', ['getProfil']),

    init() {
      this.getProfil({ id: this.$route.params.profilId, edit: false });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
